import { render, staticRenderFns } from "./tabs-template.vue?vue&type=template&id=ff81b5ea&scoped=true&"
import script from "./tabs-template.vue?vue&type=script&lang=js&"
export * from "./tabs-template.vue?vue&type=script&lang=js&"
import style0 from "./tabs-template.vue?vue&type=style&index=0&id=ff81b5ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff81b5ea",
  null
  
)

export default component.exports